module.exports = __webpack_public_path__ + "img/icn_blue_user.4d43a21e.svg";